export class RecurringSchedule {
  static FREQUENCY_DAY = 'day';
  static FREQUENCY_WEEK = 'week';
  static FREQUENCY_MONTH = 'month';
  static FREQUENCY_YEAR = 'year';
  static MONDAY = 'monday';
  static TUESDAY = 'tuesday';
  static WEDNESDAY = 'wednesday';
  static THURSDAY = 'thursday';
  static FRIDAY = 'friday';
  static SATURDAY = 'saturday';
  static SUNDAY = 'sunday';

  period: string | undefined; // day, week, month, year
  periodCount: number | undefined; // number of days, weeks, etc. ie "Every N days"
  //dayOfWeek: string | undefined;          // day of month, day of week, month and day
  //dayOfMonth: string | undefined;         // day of month, day of week, month and day
  //monthNum: number | undefined;           // day of month, day of week, month and day
  chargeUntil: string | undefined; // cancelled, date, occurrences
  numberOfCharges: number | undefined; // total number of payments to make
  firstChargeDate: string | undefined;
  firstChargeDateISO: string | undefined;
  finalChargeDate: string | undefined;
  finalChargeDateISO: string | undefined;
  nextChargeDate: string | undefined;
  recurringAgreementNumber: string | undefined;

  constructor(schedule: Partial<RecurringSchedule>) {
    Object.keys(this).forEach((key) => {
      if (schedule[key as keyof RecurringSchedule] == null) {
        //    throw Error(`${key} cannot be null`);
      }
    });
    Object.assign(this, schedule);
  }
}
